import { Link } from "react-router-dom";
import "./Navbar.css"; // CSS dosyasını import edelim

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="container">
        <Link to="/" className="logo">Blog</Link>
        <ul className="nav-links">
          <li><Link to="/" className="nav-item">Ana Sayfa</Link></li>
          <li><Link to="/about" className="nav-item">Hakkımda</Link></li>
          <li><Link to="/contact" className="nav-item">İletişim</Link></li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
